import { renderActions } from "./renderUtils";

export const getColumns = (handleShowInfo) => [
  {
    field: "id",
    headerName: "ID",
    width: 60,
  },
  // {
  //   field: "transactionUuid",
  //   headerName: "UUID",
  //   width: 300,
  // },
  {
    field: "transactionStatus",
    headerName: "Status",
    width: 200,
  },
  {
    field: "licensePlate",
    headerName: "License Plate",
    width: 300,
  },
  {
    field: "licensePlateConfidence",
    headerName: "Confidence",
    width: 150,
    valueFormatter: (value) => {
      return value ? `${parseFloat(value).toFixed(2)}` : "N/A";
    },
  },
  {
    field: "personDecision",
    headerName: "Person Decision",
    width: 350,
  },
  {
    field: "actions",
    headerName: "Actions",
    width: 150,
    renderCell: (params) => renderActions(params, handleShowInfo),
    sortable: false,
    filterable: false,
  },
];

export default getColumns;
